var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#6f29a3",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.948 24.39c0.5207 0.5207 1.3649 0.5207 1.8856 0l6.5165-6.523c1.0406-1.0415 1.0402-2.7292-8e-4 -3.7703l-6.5205-6.5205c-0.5207-0.5207-1.3649-0.5207-1.8856 0s-0.5207 1.3649 0 1.8856l5.5808 5.5809c0.5208 0.5207 0.5208 1.3649 0 1.8856l-5.576 5.5761c-0.5207 0.5207-0.5207 1.3648 0 1.8856z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/icon_arrow-right.eac4e7ac97be26c857e37b4dca90ca8d.svg";
export { ForwardRef as ReactComponent };